var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDiseases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multi-tone/Diseases"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2286 46C24.2149 46 20.1367 41.9209 20.1367 36.9081C20.1367 36.3542 20.5569 36.6029 21.1108 36.6029C21.6647 36.6029 22.1433 36.3542 22.1433 36.9081C22.1433 40.8149 25.3218 43.9934 29.2286 43.9934C33.1353 43.9934 36.3138 40.8149 36.3138 36.9081V21.8229C36.3138 21.2699 36.7632 20.8196 37.3171 20.8196C37.8711 20.8196 38.3204 21.2699 38.3204 21.8229V36.9081C38.3204 41.9209 34.2413 46 29.2286 46Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0206 18.6548C41.0206 20.7962 39.2844 22.5333 37.1421 22.5333C34.9999 22.5333 33.2637 20.7962 33.2637 18.6548C33.2637 16.5126 34.9999 14.7764 37.1421 14.7764C39.2844 14.7764 41.0206 16.5126 41.0206 18.6548Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0206 18.6548C41.0206 20.7962 39.2844 22.5333 37.1421 22.5333C34.9999 22.5333 33.2637 20.7962 33.2637 18.6548C33.2637 16.5126 34.9999 14.7764 37.1421 14.7764C39.2844 14.7764 41.0206 16.5126 41.0206 18.6548Z",
    stroke: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9297 18.6549C38.9297 19.6412 38.1299 20.441 37.1436 20.441C36.1572 20.441 35.3574 19.6412 35.3574 18.6549C35.3574 17.6685 36.1572 16.8687 37.1436 16.8687C38.1299 16.8687 38.9297 17.6685 38.9297 18.6549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.211 20.8403C34.6072 20.3062 34.2266 19.5252 34.2266 18.6547C34.2266 17.0428 35.5332 15.7362 37.1451 15.7362C37.8884 15.7362 38.5666 16.0141 39.082 16.472",
    stroke: "#F5F6F6",
    strokeWidth: 0.564,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.4766 7.81243C30.3226 7.6551 32.1728 11.3593 31.1865 18.4267C30.2802 24.9175 29.4107 30.1487 23.7753 32.1139C22.9594 32.3984 22.0908 32.5171 21.227 32.5171C20.3631 32.5171 19.4945 32.3984 18.6787 32.1139C13.0433 30.1487 12.1737 24.9175 11.2675 18.4267C10.2821 11.3593 12.1314 7.6551 14.9773 7.81243",
    stroke: "#DC5546",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.254 6C16.6539 6 16.1113 6.20066 15.7165 6.52473C15.6647 6.51813 15.6139 6.50871 15.5602 6.50871C14.847 6.50871 14.2695 7.08714 14.2695 7.79934C14.2695 8.51248 14.847 9.08997 15.5602 9.08997C15.6139 9.08997 15.6647 9.08055 15.7165 9.07489C16.1113 9.39802 16.6539 9.59868 17.254 9.59868C18.457 9.59868 19.433 8.79322 19.433 7.79934C19.433 6.80546 18.457 6 17.254 6Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3255 6C25.9256 6 26.4682 6.20066 26.8629 6.52473C26.9147 6.51813 26.9656 6.50871 27.0193 6.50871C27.7324 6.50871 28.3099 7.08714 28.3099 7.79934C28.3099 8.51248 27.7324 9.08997 27.0193 9.08997C26.9656 9.08997 26.9147 9.08055 26.8629 9.07489C26.4682 9.39802 25.9256 9.59868 25.3255 9.59868C24.1225 9.59868 23.1465 8.79322 23.1465 7.79934C23.1465 6.80546 24.1225 6 25.3255 6Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.752 22.4089C13.4656 32.049 21.035 37.4762 21.035 37.4762C25.9978 34.1083 29.1123 30.6915 30.6008 22.0886",
    stroke: "#08162D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiseases);
export default __webpack_public_path__ + "static/media/Diseases.f63fe6df68eeebcd119505996e4c86c6.svg";
export { ForwardRef as ReactComponent };